/// <reference path="app.ts" />

module Meevo {

    export class AppSettings {

        static get Default(): Meevo.Components.Common.IAppSettings {
            return {
                APP_TIME_FORMAT: 30297,
                API_ENDPOINTS: {
                    accountsync: "accountsync",
                    accountsyncDesktop: "accountsyncDesktop",
                    alertsManager: "alert",
                    alertsLog: "alertLog",
                    alertLogDetail: "alertLogDetail",
                    alertCategory: "alertCategory",
                    alertSetting: "alertSetting",
                    appointmentSchedule: "appointmentSchedule",
                    blockSchedule: "blockSchedule",
                    blockType: "blocktype",
                    businessInfo: "/tenant/businessinfo",
                    businessTypes: "businesstype",
                    locationGroups: "LocationGroup",
                    location: "location/maintenance",
                    cancellationReason: "cancellationtype",
                    client: "client",
                    clientClientType: "clientClientType",
                    clientMerge: "clientMerge",
                    clientManualMerge: "clientManualMerge",
                    discount: "discount",
                    drawer: "drawer",
                    drawerHistory: "drawerHistory",
                    drawerManager: "drawerManager",
                    drawerSession: "drawerSession",
                    fieldLabels: "settings/FieldLabels",
                    egifts: "egift",
                    shippingFees: "shippingFee",
                    employee: "employee",
                    teachers: "teacher",
                    employeeCategory: "employeeCategory",
                    employeeTemplate: "employeeTemplate",
                    employeeTemplatePromotion: "employeeTemplatePromotion",
                    inventoryCount: "inventoryCount",
                    inventoryTransfer: "inventoryTransfer",
                    notificationSetting: "notificationSetting",
                    tax: "tax",
                    productcategories: "ProductCategory",
                    giftCardType: "giftCardType",
                    referralType: "referraltype",
                    securityRole: "securityRole",
                    service: "service",
                    reportServices: "Report/Service",
                    reportScheduler: "reportScheduler",
                    reportCategories: "Report/ReportCategory",
                    alertConfigReport: "Report",
                    serviceCategory: "serviceCategory",
                    session: "session",
                    visitNoteType: "visitnotetype",
                    resource: "resource",
                    appointmentCategory: "appointmentCategory",
                    notificationTemplate: "Template",
                    onlineBookingSettings: "/settings/OnlineBooking",
                    resourceCategory: "resourceCategory",
                    distributor: "distributor",
                    manufacturer: "manufacturer",
                    meevoBi: "meevoBi",
                    clientApp:"clientApp",
                    product: "product",
                    productBulkUpdate: "productBulkUpdate",
                    productInfoModal: "product/infoModal",
                    payinoutreasons: "payinoutreasons",
                    purchaseOrder: "purchaseOrder",
                    workActivity: "workActivity",
                    appointmentRequest: "appointmentRequest",
                    equipment: "equipment",
                    stockLevels: "Inventory/StockLevel",
                    modelQuantityAnalysis: "Report/ModelQuantityAnalysisData/List",
                    inventoryTurnsAnalysis: "Report/InventoryTurnsAnalysisData/List",
                    slowMovingInventoryAnalysis: "Report/SlowMovingAnalysis/List",
                    walkinAppointment: "walkinAppointment",
                    walkInSettings: "walkInSettings",
                    paymentType: "paymenttype",
                    financialInfoSetting: "financialInfoSettings",
                    posHardware: "poshardware",
                    sale: "sale",
                    packageType: "packageType",
                    paging: "paging",
                    memberships: "membership",
                    chartPhrases: "ChartPhrase",
                    membershipTypes: "membershipType",
                    memberBenefitTemplates: "memberBenefitTemplate",
                    membershipCancellation: "membershipCancellationReason",
                    membershipManager: "membership/client",
                    ipRestriction: "ipRestriction",
                    marketPricing: "marketPricing",
                    floorLocation: "floorLocation",
                    saleHold: "salehold",
                    customData: "customData",
                    swapGroup: "swapGroup",
                    reportingHierarchy: "report/reportHierarchy",
                    report: "report",
                    transactionEditor: "transactionEditor",
                    profileSettings: "profileSettings",
                    holiday: "holidaySettings",
                    merchantAccount: "merchantAccount",
                    integration: "integration",
                    eventSchedule: "eventSchedule",
                    addOnGroup: "addOnGroup",
                    productBundles: "productBundles",
                    customBranding: "settings/customBranding",
                    clientPoint: "clientPoint",
                    compensationSettings: "settings/compensation",
                    clockInOutRulesSettings: "settings/clockInOutRules",
                    periodSettings: "settings/period",
                    cultureSettings: "settings/cultural",
                    employeeSupplyUsage: "inventory/supplyUsage",
                    clientPackageHistory: "ClientPackageHistory",
                    clientPackageHistoryById: "ClientPackageHistoryByClientId",
                    smartCenter: "smartCenter",
                    giftCardIntegration: "tenant/giftCardExternalBin",
                    miscSupplyDefinitions: "miscSupplyDefinitions",
                    inventoryReturn: "inventoryReturn",
                    clientCreditCard: "client/creditcard",
                    splitCommissionSettings: "settings/compensation/splitcommissionsettings",
                    imageGalleryCategory: "imageGalleryCategory",
                    saleProgram: "saleProgram",
                    eftControlPanel: "membership",
                    payroll: "payroll",
                    basicEmailMarketing: "basicEmailMarketing",
                    departments: "departments",
                    department: "department",
                    departmentGoal: "departmentGoal",
                    employeeGoal: "employeeGoal",
                    dashboardGoals: "dashboardGoals",
                    meevoStore: "meevoStore",
                    pointPromotionCampaign: "pointPromotionCampaign",
                    promotionCampaign: "Report/PointPromotionCampaign",
                    docsAndForms: "DocsAndForms/Form",
                    docsAndFormsKiosk: "DocsAndForms/Kiosk",
                    transworld: "settings/transworldFields",
                    techSphere: "settings/techSphere",
                    textel: "textel",
                    meevoMessenger: "meevoMessenger",
                    meevoMessengerSettings: "meevoMessenger",
                    textelBlast: "textelBlast",
                    salesRankings: "salesRankings",
                    ratingsControlPanel: "ratingsControlPanel",
                    servicesWizard: "servicesWizard",
                    students: "student",
                    ratingClientSummary: "SaleLine/SaleLineRating/SummaryByClient",
                    ratings: "SaleLine/SaleLineRating",
                    clientIntakeForm: "ClientIntakeForms/Form",
                    clientIntakeFormBuilder: "ClientIntakeForms/Builder/Form",
                    selfCheckInKioskSettings: "SelfCheckinKiosk/Settings",
                    fiveStarRatingSettings: "FiveStarRatings/Settings",
                    selfCheckInKiosk: "SelfCheckinKiosk",
                    aveda:"ExternalOrder",
                    employeeServiceTimesPricing: "EmployeeServiceTimesPricing",
                    serviceCharges: "serviceCharges",
                    fameAdvantage: 'FameAdvantage',
                    adpRunIntegration: "adpIntegration",
                    adpWfnIntegration: "adpWfnIntegration",
                    adpWiselyIntegration: "adpWiselyIntegration",
                    royaltyExport: "RoyaltyExport",
                    yieldManagementStrategy: "yieldManagement/Strategy",
                    yieldManagementProgram: "YieldManagement/Program",
                    onlinePresenceManagement: "onlinePresenceManagement",
                    onlinePresenceSettings: "Yext/Settings",
                    systemToolbox: "SystemToolbox",
                    meevoTheming: "MeevoTheming",
                    systemVersions:"System/Version",
                    usageReasons: "usageReason",
                    paymentPlans: "paymentPlan/client",
                    pbiDashboards: "pbiDashboards",
                    tippy: "tippy",
                    knowledgeArticles: "knowledgeArticles",
                },
                APP_NAME: "Meevo",
                API_ROOT: "api",
                APP_URL: "home",
                APP_COUNTRYID: "en-us",
                APP_LANGUAGEID: "1",
                APP_CURRENCY: "usdollar",
                APP_ISOCURRENCYCODE: "USD",
                APP_ISOCOUNTRYCODE: "US",
                APP_AMPMS: ["AM", "PM"],
                APP_BUSINFOSETTINGS: {},
                APP_COUNTRIES: {
                    AT: {
                        "Country": "Austria",
                        "Currency": "euro",
                        "IsoCurrencyCode": "EUR",
                        "IsoCountryCode": "AT",
                        "PostalCodeFormat": "NNNN",
                        "PostalCodeRegEx": "^\\d{4}$",
                        "CountryCallingCode": "43",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    AU: {
                        "Country": "Australia",
                        "Currency": "audollar",
                        "IsoCurrencyCode": "AUD",
                        "IsoCountryCode": "AU",
                        "PostalCodeFormat": "NNNN",
                        "PostalCodeRegEx": "^\\d{4}$",
                        "CountryCallingCode": "61",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_SUBURB|LABEL_STATE_REGION|LABEL_POSTCODE"
                    },
                    BE: {
                        "Country": "Belgium",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "BE",
                        "PostalCodeFormat": "NNNN",
                        "PostalCodeRegEx": "^\\d{4}$",
                        "CountryCallingCode": "32",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    BR: {
                        "Country": "Brazil",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "BR",
                        "PostalCodeFormat": "NNNNNNNN",
                        "PostalCodeRegEx": "^\\d{5}[\\-]?\\d{3}$",
                        "CountryCallingCode": "55",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    BH: {
                        "Country": "Bahrain",
                        "Currency": "bhdinar",
                        "IsoCurrencyCode": "BHD",
                        "IsoCountryCode": "BH",
                        "PostalCodeFormat": "NNN|NNNN",
                        "PostalCodeRegEx": "^\\d{3,4}$",
                        "CountryCallingCode": "973",
                        "LanguageId": "34",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_POSTCODE"
                    },
                    CA: {
                        "Country": "Canada",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "CAD",
                        "IsoCountryCode": "CA",
                        "PostalCodeFormat": "ANA NAN",
                        "PostalCodeRegEx": "^[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ ]?\\d[ABCEGHJ-NPRSTV-Z]\\d$$",
                        "CountryCallingCode": "1",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_PROVINCE|LABEL_POSTALCODE"
                    },
                    CH: {
                        "Country": "Switzerland",
                        "Currency": "franc",
                        "IsoCurrencyCode": "CHF",
                        "IsoCountryCode": "CH",
                        "PostalCodeFormat": "NNNN",
                        "PostalCodeRegEx": "^\\d{4}$",
                        "CountryCallingCode": "41",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|false|true",
                        "AddressBlockLabels": "LABEL_BUILDING|LABEL_STREET|LABEL_CITY|LABEL_STATE|LABEL_POSTALCODE"
                    },
                    CN: {
                        "Country": "China",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "CN",
                        "PostalCodeFormat": "NNNNNN",
                        "PostalCodeRegEx": "^\\d{6}$",
                        "CountryCallingCode": "86",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    DE: {
                        "Country": "Germany",
                        "Currency": "euro",
                        "IsoCurrencyCode": "EUR",
                        "IsoCountryCode": "DE",
                        "PostalCodeFormat": "NNNNN",
                        "PostalCodeRegEx": "^\\d{5}$",
                        "CountryCallingCode": "49",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_POSTALTOWN|LABEL_POSTALCODE"
                    },
                    DK: {
                        "Country": "Denmark",
                        "Currency": "krone",
                        "IsoCurrencyCode": "DKK",
                        "IsoCountryCode": "DK",
                        "PostalCodeFormat": "NNNN",
                        "PostalCodeRegEx": "^\\d{4}$",
                        "CountryCallingCode": "45",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    ES: {
                        "Country": "Spain",
                        "Currency": "euro",
                        "IsoCurrencyCode": "EUR",
                        "IsoCountryCode": "ES",
                        "PostalCodeFormat": "NNNNN",
                        "PostalCodeRegEx": "^\\d{5}$",
                        "CountryCallingCode": "34",
                        "LanguageId": "92",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|false|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_PROVINCE|LABEL_POSTALCODE"
                    },
                    FI: {
                        "Country": "Finland",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "FI",
                        "PostalCodeFormat": "NNNNN",
                        "PostalCodeRegEx": "^\\d{5}$",
                        "CountryCallingCode": "358",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    FR: {
                        "Country": "France",
                        "Currency": "franc",
                        "IsoCurrencyCode": "FRF",
                        "IsoCountryCode": "FR",
                        "PostalCodeFormat": "NNNNN",
                        "PostalCodeRegEx": "^\\d{2}[ ]?\\d{3}$",
                        "CountryCallingCode": "33",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    GB: {
                        "Country": "United Kingdom",
                        "Currency": "pound",
                        "IsoCurrencyCode": "GBP",
                        "IsoCountryCode": "GB",
                        "PostalCodeFormat": "AANN NAA|ANNNAA|AANANAA|ANNAA|ANANAA|ANNNAA",
                        /*  stackoverflow.com/questions/164979/uk-postcode-regex-comprehensive  */
                        "PostalCodeRegEx": "^(([A-Z]{1,2}\\d[A-Z\\d]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?\\d[A-Z]{2}|BFPO ?\\d{1,4}|(KY\\d|MSR|VG|AI)[ -]?\\d{4}|[A-Z]{2} ?\\d{2}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$",
                        "CountryCallingCode": "44",
                        "LanguageId": "34",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_BUILDING|LABEL_STREET|LABEL_CITY|LABEL_COUNTY|LABEL_POSTALCODE"
                    },
                    UK: {
                        "Country": "United Kingdom",
                        "Currency": "pound",
                        "IsoCurrencyCode": "GBP",
                        "IsoCountryCode": "UK",
                        "PostalCodeFormat": "AANN NAA|ANNNAA|AANANAA|ANNAA|ANANAA|ANNNAA",
                        "PostalCodeRegEx": "^(([A-Z]{1,2}\\d[A-Z\\d]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?\\d[A-Z]{2}|BFPO ?\\d{1,4}|(KY\\d|MSR|VG|AI)[ -]?\\d{4}|[A-Z]{2} ?\\d{2}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$",
                        "CountryCallingCode": "44",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_BUILDING|LABEL_STREET|LABEL_CITY|LABEL_COUNTY|LABEL_POSTALCODE"
                    },
                    GR: {
                        "Country": "Greece",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "GR",
                        "PostalCodeFormat": "NNNNN",
                        "PostalCodeRegEx": "^\\d{3}[ ]?\\d{2}$",
                        "CountryCallingCode": "30",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    ID: {
                        "Country": "Indonesia",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "ID",
                        "PostalCodeFormat": "NNNNN",
                        "PostalCodeRegEx": "^\\d{5}$",
                        "CountryCallingCode": "62",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    IN: {
                        "Country": "India",
                        "Currency": "rupee",
                        "IsoCurrencyCode": "INR",
                        "IsoCountryCode": "IN",
                        "PostalCodeFormat": "NNNNNN",
                        "PostalCodeRegEx": "^\\d{6}$",
                        "CountryCallingCode": "91",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    IE: {
                        "Country": "Ireland",
                        "Currency": "euro",
                        "IsoCurrencyCode": "EUR",
                        "IsoCountryCode": "IE",
                        "PostalCodeFormat": "NNNNN",
                        "PostalCodeRegEx": "^[AC-Y]{1}[0-9]{1}[0-9W]{1}[ \-]?[0-9AC-Y]{4}$",
                        "CountryCallingCode": "353",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    IT: {
                        "Country": "Italy",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "IT",
                        "PostalCodeFormat": "NNNNN",
                        "PostalCodeRegEx": "^\\d{5}$",
                        "CountryCallingCode": "39",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    JP: {
                        "Country": "Japan",
                        "Currency": "yen",
                        "IsoCurrencyCode": "JPY",
                        "IsoCountryCode": "JP",
                        "PostalCodeFormat": "NNNNNNN",
                        "PostalCodeRegEx": "^\\d{3}-\\d{4}$",
                        "CountryCallingCode": "81",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    LU: {
                        "Country": "Luxembourg",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "LU",
                        "PostalCodeFormat": "NNNN|L-NNNN",
                        "PostalCodeRegEx": "^\\d{4}$",
                        "CountryCallingCode": "352",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    MX: {
                        "Country": "Mexico",
                        "Currency": "pesos",
                        "IsoCurrencyCode": "MXN",
                        "IsoCountryCode": "MX",
                        "PostalCodeFormat": "NNNNN",
                        "PostalCodeRegEx": "^\\d{5}$",
                        "CountryCallingCode": "52",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    MY: {
                        "Country": "Malaysia",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "MY",
                        "PostalCodeFormat": "NNNNN",
                        "PostalCodeRegEx": "^\\d{5}$",
                        "CountryCallingCode": "60",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    NL: {
                        "Country": "Netherlands",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "NL",
                        "PostalCodeFormat": "NNNN",
                        "PostalCodeRegEx": "^\\d{4}[ ]?[A-Z]{2}$",
                        "CountryCallingCode": "31",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    NO: {
                        "Country": "Norway",
                        "Currency": "krone",
                        "IsoCurrencyCode": "NOK",
                        "IsoCountryCode": "NO",
                        "PostalCodeFormat": "NNNN",
                        "PostalCodeRegEx": "^\\d{4}$",
                        "CountryCallingCode": "47",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    NZ: {
                        "Country": "New Zealand",
                        "Currency": "nzdollar",
                        "IsoCurrencyCode": "NZD",
                        "IsoCountryCode": "NZ",
                        "PostalCodeFormat": "NNNN",
                        "PostalCodeRegEx": "^\\d{4}$",
                        "CountryCallingCode": "64",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_SUBURB|LABEL_STATE_REGION|LABEL_POSTCODE"
                    },
                    PH: {
                        "Country": "Philippines",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "PH",
                        "PostalCodeFormat": "NNNN",
                        "PostalCodeRegEx": "^\\d{4}$",
                        "CountryCallingCode": "63",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    PR: {
                        "Country": "Puerto Rico",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "PR",
                        "PostalCodeFormat": "NNNNN",
                        "PostalCodeRegEx": "^00[679]\\d{2}([ \\-]\\d{4})?$",
                        "CountryCallingCode": "+1",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    PT: {
                        "Country": "Portugal",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "PT",
                        "PostalCodeFormat": "NNNN|NNNN-nnn|NNNNnnn",
                        "PostalCodeRegEx": "^\\d{4}([\\-]\\d{3})?$",
                        "CountryCallingCode": "351",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    SE: {
                        "Country": "Sweden",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "SE",
                        "PostalCodeFormat": "NNNNN",
                        "PostalCodeRegEx": "^\\d{3}[ ]?\\d{2}$",
                        "CountryCallingCode": "46",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    SG: {
                        "Country": "Singapore",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "SG",
                        "PostalCodeFormat": "NNNNNN",
                        "PostalCodeRegEx": "^\\d{6}$",
                        "CountryCallingCode": "65",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    TH: {
                        "Country": "Thailand",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "TH",
                        "PostalCodeFormat": "NNNNN",
                        "PostalCodeRegEx": "^\\d{5}$",
                        "CountryCallingCode": "66",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    TT: {
                        "Country": "Trinidad & Tobago",
                        "Currency": "ttdollar",
                        "IsoCurrencyCode": "TTD",
                        "IsoCountryCode": "TT",
                        "PostalCodeFormat": "NNNNNN",
                        "PostalCodeRegEx": "^\\d{6}$",
                        "CountryCallingCode": "868",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|false|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    US: {
                        "Country": "United States",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "US",
                        "PostalCodeFormat": "NNNNN-NNNN",
                        "PostalCodeRegEx": "^\\d{5}([\\-]\\d{4})?$",
                        "CountryCallingCode": "1",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    },
                    GI: {
                        "Country": "Gibraltar",
                        "Currency": "pound",
                        "IsoCurrencyCode": "GIP",
                        "IsoCountryCode": "GI",
                        "PostalCodeFormat": "GX11 1AA",
                        /*  stackoverflow.com/questions/164979/uk-postcode-regex-comprehensive  */
                        "PostalCodeRegEx": "^[Gg][Xx][1]{2}\\s{0,1}[1][Aa]{2}$",
                        "CountryCallingCode": "350",
                        "LanguageId": "34",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_BUILDING|LABEL_STREET|LABEL_CITY|LABEL_COUNTY|LABEL_POSTALCODE"
                    },
                    OTHER: {
                        "Country": "Other",
                        "Currency": "usdollar",
                        "IsoCurrencyCode": "USD",
                        "IsoCountryCode": "OTHER",
                        "PostalCodeFormat": "NNNNN-NNNN",
                        "PostalCodeRegEx": ".*",
                        "CountryCallingCode": "1",
                        "LanguageId": "1",
                        "PhoneFormat": "#####",
                        "PhoneRegEx": "^##$",
                        "AddressBlockShows": "true|true|true|true|true",
                        "AddressBlockLabels": "LABEL_ADDRESS1|LABEL_ADDRESS2|LABEL_CITY|LABEL_STATE|LABEL_ZIPCODE"
                    }
                },
                APP_FIELDLABELS: {},
                LOGIN_URL: "login",
                ROUTE_NAMES: {
                    accountsync: "quickbooksOnline",
                    appointmentBook: "appointmentBook",
                    standingBlocks: "standingBlocks",
                    blockTypes: "blockTypes",
                    businessInfo: "businessInfo",
                    businessTypes: "businessTypes",
                    businessPreferences: "businesssettings",
                    consumerAppSettings: "consumerAppSettings",
                    locationGroups: "locationGroups",
                    location: "location",
                    notificationSetting: "notificationSetting",
                    tax: "tax",
                    cancellationReasons: "cancellationReasons",
                    client: "client",
                    clientClientType: "clientClientType",
                    clientMerge: "clientMerge",
                    clientManualMerge: "clientManualMerge",
                    confirmationManager: "confirmationManager",
                    controlGallery: "controllGallery",
                    drawer: "drawer",
                    drawerHistory: "drawerHistory",
                    drawerManager: "drawerManager",
                    egifts: "egift",
                    shippingFees: "shippingFees",
                    employee: "employee",
                    teachers: "teachers",
                    employeeCategories: "employeeCategories",
                    employeeTemplates: "employeeTemplates",
                    employeeTemplatePromotions: "employeeTemplatePromotions",
                    emmaAccountSettings: "emmaAccountSettings",
                    fieldLabels: "fieldLabels",
                    giftCardTypes: "giftCardTypes",
                    home: "home",
                    itemDetail: "itemDetail",
                    localizationTest: "localizationTest",
                    login: "login",
                    meevoTheming: "meevoTheming",
                    onlineBooking: "onlineBooking",
                    referralTypes: "referralTypes",
                    register: "register",
                    reports: "reports",
                    performanceInsights: "performanceInsights",
                    insightsUserManagement: "insightsUserManagement",
                    reportScheduler: "reportScheduler",
                    reportingHierarchy: "reportingHierarchy",
                    search: "search",
                    securityRoles: "securityRoles",
                    securityRolesManager: "securityRolesManager",
                    services: "services",
                    serviceCategories: "serviceCategories",
                    standingAppointments: "standingAppointments",
                    styleGallery: "styleGallery",
                    meevoPay: "meevo-pay/merchant-account",
                    visitNoteTypes: "visitNoteTypes",
                    resources: "resources",
                    appointmentCategories: "appointmentCategories",
                    waitList: "waitList",
                    resourceCategory: "resourceCategory",
                    distributor: "distributor",
                    notificationTemplates: "notificationTemplates",
                    workActivities: "workActivities",
                    product: "product",
                    productBulkUpdate: "product-bulk-update",
                    productInfoModal: "productInfoModal",
                    payinoutreasons: "payinoutreasons",
                    equipment: "equipment",
                    stockLevels: "stockLevels",
                    modelQuantityAnalysis: "modelQuantityAnalysis",
                    inventoryTurnsAnalysis: "inventoryTurnsAnalysis",
                    slowMovingInventoryAnalysis: "slowMovingInventoryAnalysis",
                    walkinManagerSettings: "walkinManagerSettings",
                    walkinManager: "walkinManager",
                    walkinManagerDisplay: "walkinManagerDisplay",
                    callCenter: "bookingAgent",
                    productCategories: "productCategories",
                    distributors: "distributors",
                    meevoBi: "meevoBi",
                    clientApp:"clientApp",
                    manufacturer: "manufacturer",
                    manufacturers: "manufacturers",
                    discounts: "discounts",
                    walkinManagerKiosk: "walkinManagerKiosk",
                    onlineBookingSettings: "onlineBookingSettings",
                    financialInfoSetting: "financialInfoSettings",
                    userDefinedControls: "userDefinedControls",
                    paymentType: "paymentType",
                    posHardware: "posHardware",
                    packageTypes: "packageTypes",
                    packages: "packages",
                    paging: "paging",
                    purchaseOrder: "purchaseOrder",
                    memberships: "memberships",
                    membershipTypes: "membershipTypes",
                    membershipDefinitions: "membershipDefinitions",
                    memberBenefitTemplates: "memberBenefitTemplates",
                    membershipCancellation: "membershipCancellation",
                    membershipManager: "membershipManager",
                    floorLocation: "floorLocation",
                    swapGroups: "swapGroups",
                    inventoryCount: "inventoryCount",
                    inventoryTransfer: "inventoryTransfer",
                    ipRestrictions: "ipRestrictions",
                    marketPricing: "marketPricing",
                    transactionEditor: "transactionEditor",
                    profileSettings: "profileSettings",
                    holiday: "holiday",
                    merchantAccounts: "merchantAccounts",
                    integrations: "integrations",
                    eventSchedules: "eventSchedules",
                    timeClock: "timeClock",
                    addOnGroup: "addOnGroup",
                    productBundles: "productBundles",
                    customBranding: "customBranding",
                    advancedCustomBranding: "advancedcustombranding",
                    clientPoint: "clientPoint",
                    compensationSettings: "compensationSettings",
                    clockInOutRulesSettings: "clockInOutRulesSettings",
                    periodSettings: "periodSettings",
                    cultureSettings: "cultureSettings",
                    employeeSupplyUsage: "employeeSupplyUsage",
                    smartCenters: "smartCenters",
                    giftCardBalance: "giftCardBalance",
                    giftCardIntegration: "giftCardIntegration",
                    miscSupplyDefinitions: "miscSupplyDefinitions",
                    inventoryReturns: "inventoryReturns",
                    splitCommissionSettings: "splitCommissionSettings",
                    activityLog: "activityLog",
                    alertsManager: "alertsManager",
                    alertsLog: "alertsLog",
                    imageGalleryCategory: "imageGalleryCategory",
                    packageLookup: "packageLookup",
                    saleProgram: "saleProgram",
                    eftControlPanel: "eftControlPanel",
                    sandbox: "sandbox",
                    payroll: "payroll",
                    basicEmailMarketing: "basicEmailMarketing",
                    departments: "departments",
                    department: "department",
                    departmentGoal: "departmentGoal",
                    employeeGoal: "employeeGoal",
                    dashboardGoals: "dashboardGoals",
                    meevoStore: "meevoStore",
                    pointPromotionCampaign: "pointPromotionCampaign",
                    docsAndForms: "docsAndForms",
                    docsAndFormsKiosk: "docsAndFormsKiosk",
                    transworld: "transworld",
                    techSphere: "techSphere",
                    meevoMessenger: "meevoMessenger",
                    meevoMessengerSettings: "meevoMessengerSettings",
                    textelBlast: "textelBlast",
                    salesRankings: "salesRankings",
                    ratingsControlPanel: "ratingsControlPanel",
                    servicesWizard:"servicesWizard",
                    student: "student",
                    help: "help",
                    meevoInspo: "meevo-inspo",
                    referAFriend: "refer-a-friend",
                    meevoFacebook: "meevoFacebook",
                    remoteTraining: "remote-training",
                    clientIntake: "clientIntake",
                    clientIntakeForm: "clientIntakeForm",
                    selfCheckInKiosk: "selfCheckInKiosk",
                    selfCheckInKioskSettings: "selfCheckInKioskSettings",
                    aveda: "aveda",
                    employeeServiceTimesPricing: "employeeServiceTimesPricing",
                    fiveStarRatingSetting: "fiveStarRatingSetting",
                    serviceCharges: "serviceCharges",
                    fameAdvantage: 'fameAdvantage',
                    adpRunIntegration: "adpRunIntegration",
                    adpWfnIntegration: "adpWfnIntegration",
                    adpWiselyIntegration: "adpWiselyIntegration",
                    royaltyExport: "royaltyExport",
                    aiReceptionist: "aiReceptionist",
                    quickbooksDesktop: "quickbooksDesktop",
                    onlinePresenceManagement: "onlinePresenceManagement",
                    onlinePresenceSettings: "onlinePresenceSettings",
                    systemToolbox: "systemToolbox",
                    yieldManagementStrategy: "yieldManagementStrategy",
                    yieldManagementProgram: "yieldManagementProgram",
                    interopSample: "interopSample",
                    newSchedules: "newSchedules",
                    newFormBuilder: "docs-and-forms",
                    newIntakeFormBuilder: "client-intake-form",
                    csvExport: "dataexport",
                    systemVersions: "systemVersions",
                    usageReasons: "usageReasons",
                    paymentPlans: "payment-plans",
                    paymentRequests: "payment-requests",
                    releaseNotes: "release-notes",
                    pbiDashboards: "pbi-dashboards",
                    advancedDashboardsHelp: "advancedDashboardsHelp",
                    myMeevoApp: "my-meevo-app",
                    timeOffRequests: "time-off-requests",
                    tippy: "tippy",
                    knowledgeArticles: "knowledgeArticles",
                    schedulesManager: "schedule-manager",
                    zapier: "zapier",
                    onlineMembershipSettings: "onlinemembershipsettings",
                    twoWaySmsOnboarding: "twowaysmsonboarding",
                    salonInteractive: "salon-interactive",
                    merchantOnboardingTesting: "merchantonboardingtesting",
                    bulkLiabilityUpdate: "bulkLiabilityUpdate",
                    bulkLiabilityTransfer: "bulkLiabilityTransfer",
                    //chartPhrases: "chart-phrases",
                    chartPhrases: "chartPhrases",
                    charts: "charts",
                    clientRecordManagement: "clientRecordManagement",
                    upsellOpportunities: "upsellOpportunities",
                },
                AUDIT_NAMES: {
                    appointmentCategories: "Appointment Category Search screen",
                    activityLog: "Activity Log",
                    alertsLog: "Alert Logs",
                    charts: "Charts",
                    clientRecordManagement: "Client Record Management",
                    alertsManager: "Alert Manager",
                    blockTypes: "Block Type Search screen",
                    businessPreferences: "Business Preferences screen",
                    standingBlocks: "Block Schedule Search screen",
                    basicEmailMarketing: "Client Selection Export",
                    businessTypes: "Business Type Search screen",
                    payroll: "Payroll",
                    cancellationReasons: "Cancellation Reason Search screen",
                    client: "Client Search screen",
                    clientClientType: "Client Type Search screen",
                    clientPoint: "Client Point Manager Search screen",
                    confirmationManager: "Confirmation Manager screen",
                    discounts: "Discount Search screen",
                    distributors: "Distributor Search screen",
                    drawer: "Drawer Search screen",
                    drawerHistory: "Drawer History screen",
                    drawerManager: "Drawer Manager screen",
                    eftControlPanel: "Eft Control Panel screen",
                    egifts: "Egift",
                    shippingFees: "Shipping Fees",
                    employee: "Employee Search screen",
                    employeeCategories: "Employee Category Search screen",
                    employeeTemplates: "Employee Template Search screen",
                    employeeTemplatePromotions: "Employee Promotion Search screen",
                    employeeSupplyUsage: "Employee Supply Usage screen",
                    floorLocation: "Floor Location Search screen",
                    giftCardBalance: "Gift Card Balance screen",
                    giftCardTypes: "Gift Card Type Search screen",
                    home: "Meevo Home Page",
                    imageGalleryCategory: "Image Gallery Category Search screen",
                    inventoryCount: "Inventory Count Search screen",
                    inventoryReturns: "Inventory Return Search screen",
                    inventoryTransfer: "Inventory Transfer Search screen",
                    ipRestrictions: "IP Restrictions",
                    clientMerge: "IntelliMerge Page",
                    clientManualMerge: "Manual Merge",
                    locationGroups: "Location Group Search screen",
                    location: "Location Maintenance Search screen",
                    memberships: "Membership Search screen",
                    membershipCancellation: "Membership Cancellation Reason Search screen",
                    memberBenefitTemplates: "Member Benefit Template Search screen",
                    membershipManager: "Membership Manager screen",
                    membershipTypes: "Membership Type Search screen",
                    marketPricing: "Market Pricing Search screen",
                    saleProgram: "Mark Items On Sale Search screen",
                    manufacturers: "Manufacturer Search screen",
                    merchantAccounts: "Merchant Account Search screen",
                    miscSupplyDefinitions: "Miscellaneous Supply Search screen",
                    notificationTemplates: "Notification Template Search screen",
                    packageTypes: "Package Search screen",
                    packageLookup: "Package Lookup",
                    payinoutreasons: "Pay In/Out Reason Search screen",
                    paymentType: "Payment Type Search screen",
                    product: "Product Search screen",
                    productBulkUpdate: "Product Bulk Update Search Screen",
                    productBundles: "Product Bundle Search screen",
                    productCategories: "Product Category Search screen",
                    profileSettings: "My Profile screen",
                    purchaseOrder: "Purchase Orders Search screen",
                    referralTypes: "Referral Type Search screen",
                    resources: "Resource Search screen",
                    resourceCategory: "Resource Category Search screen",
                    securityRoles: "Security Role Search screen",
                    securityRolesManager: "Security Roles Manager",
                    services: "Service Search screen",
                    addOnGroup: "Service AddOn Mapping Search screen",
                    smartCenters: "Smart Center Designer Search screen",
                    standingAppointments: "Standing Definition Search screen",
                    swapGroups: "Swap Group",
                    transactionEditor: "Transaction Editor",
                    visitNoteTypes: "Visit Note Type Search screen",
                    userDefinedControls: "User Defined Field",
                    walkinManager: "WalkIn Manager",
                    walkinManagerDisplay: "WalkIn Manager Display",
                    walkinManagerKiosk: "WalkIn Manager Kiosk",
                    walkinManagerSettings: "WalkIn Manager Setting Main Settings",
                    workActivities: "Work Activity Search screen",
                    departments: "Department Search screen",
                    pointPromotionCampaign: "Point Promotion Campaign Search screen",
                    dashboardGoals: "Goals Dashboard",
                    docsAndForms: "Docs And Forms Search screen",
                    docsAndFormsKiosk: "Docs And Forms Kiosk Mode",
                    student: "Student Search screen",
                    teachers: "Teacher Search screen",
                    selfCheckInKiosk: "Self Check-In Kiosk screen",
                    serviceCharges: "Service Charges",
                    meevoBi: "Meevo Business Intelligence",
                    adpRunIntegration: "ADP Integration Screen",
                    adpWfnIntegration: "ADP WFN Integration Screen",
                    clientApp:"MeGo",
                    adpWiselyIntegration: "ADP Wisely Integration Screen",
                    royaltyExport: "Royalty Export",
                    aiReceptionist: "AI Receptionist",
                    accountsync: 'Quickbooks Online',
                    quickbooksDesktop: "Quickbooks Desktop",
                    systemToolbox: "System Toolbox",
                    yieldManagementStrategy: "Yield Management Strategy Search screen",
                    yieldManagementProgram: "Yield Management Program Search screen",
                    usageReasons:"Usage Reasons",
                    paymentPlans: "Payment Plan Manager",
                    meevoPay: "MeevoPay",
                    tippy: "Tippy",
                    bulkLiabilityUpdate: "Bulk Liability Update",
                    bulkLiabilityTransfer: "Bulk Liability Transfer",
                    chartPhrases: "Chart Phrases",
                    upsellOpportunities: "Upsell Opportunities Overview",
                    //salonInteractive: ""
                },
                REPORT_SERVER_URL: "/Reports/",
                SECURITY_ACCESS_KEYS: "",
                SERVER_EVENTS_API_URL: "",
                SERVER_EVENTS_ENABLED: false,
                MEEVO_MODULES_URL: AppSettings.modulesUrl,
                INTEROP_URL: AppSettings.interopUrl
            }
        }        

        private static readonly LOCAL_INTEROP_URL = 'http://localhost:4444';

        static get interopUrl(): string {
            if (window.location.origin.indexOf('localhost') >= 0) {
                return AppSettings.LOCAL_INTEROP_URL;
            } else {
                return `${window.location.origin}`;
            }
        }

        static get modulesUrl(): string {
            if (window.location.origin.indexOf('localhost') >= 0) {
                return AppSettings.LOCAL_INTEROP_URL;
            } else {
                return `${window.location.origin}/MeevoShellv2`;
            }
        }

        private static readonly LOCAL_QS_MICROSERVICE_URL = 'http://localhost:5100';

        static get qsMicroserviceUrl(): string {
            if (window.location.origin.indexOf('localhost') >= 0) {
                return AppSettings.LOCAL_QS_MICROSERVICE_URL;
            } else {
                return window['QuickSightMicroserviceUrl'] || '';
            }
        }
    }
    angular.module("meevo")
        .constant("meevo.AppSettings", AppSettings.Default);
}
